const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Checkbox", "uipress-lite"),
  moduleName: "uip-checkbox-input",
  description: __("Outputs a checkbox type input", "uipress-lite"),
  group: "form",
  icon: "check_box",
};
